// Configuration constants
const CONFIG = {
    animationClass: 'animate',
    animatedClass: 'animated',
    defaultOffset: '100px',
    headerElement: 'desktopHeader',
    topClass: 'is-at-top',
    thresholdClass: 'is-beyond-scroll-threshold',
    utilitiesClass: 'disable-utilities',
    thresholdDelay: 250,
    thresholdResetDelay: 5
}

// DOM elements and derived values 
const elementsToShow = document.querySelectorAll( `.${CONFIG.animationClass}` )
const desktopHeader = document.getElementById( CONFIG.headerElement )
const scrollThreshold = desktopHeader ? desktopHeader.offsetHeight : 0

// State variables
let utilityEnableTimeout = null
let lastScrollY = 0
let ticking = false

/**
 * Sets up the intersection observers for animation elements
 */
const setupAnimationObservers = () => {
    // Create default observer
    const defaultObserver = createAnimationObserver( CONFIG.defaultOffset )

    // Process each element
    elementsToShow.forEach( element => {
        const customOffset = element.dataset.animateOffset

        if ( customOffset ) {
            // Create and use custom observer for this element
            const customObserver = createAnimationObserver( customOffset )
            customObserver.observe( element )
        } else {
            // Use default observer
            defaultObserver.observe( element )
        }
    } )
}

/**
 * Creates an intersection observer with specified offset
 */
const createAnimationObserver = ( offset ) => {
    return new IntersectionObserver( ( entries ) => {
        entries.forEach( entry => {
            if ( entry.isIntersecting && !entry.target.classList.contains( CONFIG.animatedClass ) ) {
                entry.target.classList.add( CONFIG.animatedClass )
                // Optional: unobserve once animated
                // observer.unobserve( entry.target )
            }
        } )
    }, {
        rootMargin: `-${offset} 0px 0px 0px`,
        threshold: 0
    } )
}

/**
 * Sets up the scroll event listener with throttling
 */
const setupScrollHandler = () => {
    window.addEventListener( 'scroll', () => {
        lastScrollY = window.scrollY
        if ( !ticking ) {
            window.requestAnimationFrame( updateScrollState )
            ticking = true
        }
    }, { passive: true } )

    // Initial state check
    updateScrollState()
}

/**
 * Updates document classes based on scroll position
 */
const updateScrollState = () => {

    // Top state
    document.body.classList.toggle( CONFIG.topClass, lastScrollY <= 0 )

    // Threshold state
    updateThresholdState( lastScrollY )

    ticking = false
    
}

/**
 * Updates threshold-related classes
 */
const updateThresholdState = ( scrollAmount ) => {
    if ( scrollAmount >= scrollThreshold ) {
        clearTimeout( utilityEnableTimeout )
        document.body.classList.add( CONFIG.thresholdClass )
        utilityEnableTimeout = setTimeout( () => 
            document.body.classList.add( CONFIG.utilitiesClass ), CONFIG.thresholdDelay )
    } else {
        clearTimeout( utilityEnableTimeout )
        document.body.classList.remove( CONFIG.utilitiesClass )
        utilityEnableTimeout = setTimeout( () => 
            document.body.classList.remove( CONFIG.thresholdClass ), CONFIG.thresholdResetDelay )
    }
}

/**
 * Fallback for browsers that don't support IntersectionObserver
 */
const showAllAnimationElements = () => {
    
    elementsToShow.forEach( element => element.classList.add( CONFIG.animatedClass ) )

}

/**
 * Main initialization function
 */
const init = () => {
    if ( 'IntersectionObserver' in window ) {
        setupAnimationObservers()
        setupScrollHandler()
    } else {
        showAllAnimationElements()
    }
}

// Export API
export default { init }